<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load DCA queue"
    data-testid="warrants-dca-queue"
    searchable
    search-placeholder="Search account number"
    :fetcher="fetchQueue"
    :items-from="itemsFrom"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
  } from "@/types/components/SoDataTable"
  import {
    accountNumberColumn,
    createdAtColumn,
    deletedColumn,
    idColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsDcaQueueListResult,
    WarrantsDcaQueueService,
  } from "@/services/admin/WarrantsDcaQueueService"

  const headers: SoDataTableHeader[] = [
    idColumn,
    accountNumberColumn,
    createdAtColumn,
    {
      title: "Processed At",
      key: "processedAt",
      type: SoDataTableColumnType.DATE_TIME,
      sortable: true,
      sortKey: "processed_at",
      fallbackValue: "—",
    },
    {
      title: "Processed",
      key: "isProcessed",
      type: SoDataTableColumnType.YES_OR_NO,
      sortable: false,
    },
    deletedColumn,
  ]

  export default defineComponent({
    components: {
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
      }
    },
    methods: {
      fetchQueue({ search, page, pageSize, orderBy }: SoDataTableOptions) {
        return WarrantsDcaQueueService.getQueue(search, page, pageSize, orderBy)
      },
      itemsFrom(result: WarrantsDcaQueueListResult) {
        return result.queue
      },
    },
  })
</script>
